/**
 * Selpers Smoke Tool
 * @author Mario Sassmann <mario.sassmann@speedy-space.com>
 *
 * heavily based on @see https://www.smokefree.ch/
 */

( function () {

    let intNumbersCounter = 0;
    let intCig = 0;
    let intCups = 0;
    let intCO = 0;

    let intStepCig = 0;
    let intStepCups = 0;
    let intStepCO = 0;

    let intCurCig = 0;
    let intCurCups = 0;
    let intCurCO = 0;

    let intCalculatorSlide = 1;
    let objInterval;

    document.querySelector( '.boxCalculatorRight button' )
        .addEventListener( 'click', onButtonClick );

    function onButtonClick() {
        let bIsError = false;

        const calcyear_elem = document.getElementById( 'calcYear' );
        const calccig_elem = document.getElementById( 'calcCig' );
        const calcteer_elem = document.getElementById( 'calcTeer' );

        if ( ! calcyear_elem.value ) {
            calcyear_elem.classList.add( 'error' );
            bIsError = true;
        } else {
            calcyear_elem.classList.remove( 'error' );
        }

        if ( ! calccig_elem.value ) {
            calccig_elem.classList.add( 'error' );
            bIsError = true;
        } else {
            calccig_elem.classList.remove( 'error' );
        }

        if ( ! calcteer_elem.value ){
            calcteer_elem.classList.add( 'error' );
            bIsError = true;
        } else {
            calcteer_elem.classList.remove( 'error' );
        }

        if ( ! bIsError ) {
            const intDays = getDays( calcyear_elem.value );

            intCig = intDays * calccig_elem.value;

            intCups = Math.round(calccig_elem.value * calcteer_elem.value * 0.7 * intDays / 1000 * 1.2 / 120 * 10 ) / 10;
            // Cig x Teer (mg)x 0.7 x Tage / 1000

            intCO = Math.round(( calccig_elem.value * 10 * intDays * 22.4 / ( 1000 * 28 ) ) * 100 ) / 100;
            // Cig x CO x Tage x 22,4 / (1000 x 28)

            intStepCig = intCig / 100;
            intStepCups = intCups / 100;
            intStepCO =  intCO / 100;

            console.log( intStepCups + "-" + intCups );
            console.log( intStepCig + "-" + intCig );
            console.log( intStepCO + "-" + intCO );

            objInterval = setInterval( countNumbers, 20 );

            document.getElementById( 'boxCalculatorForm' ).style.display = 'none';
            document.getElementById( 'boxCalculatorResult' ).style.display= 'block';
        }
    }

    function getDays( strYear ) {
        if ( ! strYear ) {
            return null;
        }

        const check1 = new Date();
        const check2 = new Date( strYear, 1, 1 );
        return Math.round( Math.abs( check1 - check2 ) / ( 1000 * 60 * 60 * 24 ) );
    }

    function countNumbers() {
        const resCig_elem = document.getElementById( 'resCig');
        const resCups_elem = document.getElementById( 'resCups' );
        const resco_elem = document.getElementById( 'resCO' );

        if ( intNumbersCounter === 100 ) {
            clearInterval( objInterval );

            resCig_elem.textContent = intCig;
            resCups_elem.textContent = intCups;
            resco_elem.textContent = intCO;

            setTimeout( function () {
                setInterval( function () {
                    let intNextCalculatorSlide = 0;

                    if ( intCalculatorSlide < 4 ) {
                        intNextCalculatorSlide = intCalculatorSlide + 1;
                    } else {
                        intNextCalculatorSlide = 1;
                    }

                    intCalculatorSlide = intNextCalculatorSlide;
                }, 4000 );
            }, 6000 );
        } else {
            intCurCig = intCurCig + intStepCig;
            intCurCups = intCurCups + intStepCups;
            intCurCO = intCurCO + intStepCO;

            resCig_elem.textContent = Math.round( intCurCig ).toString();
            resCups_elem.textContent = ( Math.round( intCurCups * 10 ) / 10 ).toString();
            resco_elem.textContent = ( Math.round( intCurCO * 100 ) / 100 ).toString();

            intNumbersCounter++;
        }
    }

} ) ();
